// Utils
import useCurrentSession from '@/utils/hooks/user/useCurrentSession';
import { ToastsProvider } from '@/utils/hooks/context/toast/useToastsContext';

// Components
import Loader from '@/components/base/Loader';
import { DatepickerGlobalStoreProvider } from '@/utils/zustand/providers/datepicker-global-provider';

export function GlobalWrapper({ children }: { children: React.ReactNode }) {
    const { isLoading } = useCurrentSession();

    if (isLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader className="h-6 w-6 text-icoBlue" />
            </div>
        );
    }

    return (
        <DatepickerGlobalStoreProvider>
            <ToastsProvider>
                <div className="flex h-full w-full">{children}</div>
            </ToastsProvider>
        </DatepickerGlobalStoreProvider>
    );
}
